import {all} from 'redux-saga/effects';
import errorSaga from './../error/saga'
import {call, select, put, takeEvery, takeLatest} from 'redux-saga/effects'
import * as actions from "./actions";
import * as errorActions from "./../error/actions";
import OpenAmendmentApi from "./OpenAmendmentApi";
import * as selectors from "./selectors";
import {HISTORY} from "../util/History";
import SearchUrlUtil from "./SearchUrlUtil";
import {OPEN_AMENDMENTS_PATH} from "../ajax/sdgOnlinePaths";


function* initTable(action) {
  try {
    const urlState = yield call(SearchUrlUtil.extractSearch, action.qs);
    yield call(updateTable, {'stateToChange': urlState})
  } catch (e) {
    yield put(errorActions.Saga.setError(e));
  }
}

function* updateTable(action) {
  try {
    yield put(actions.Generator.tableStateChange(action.stateToChange));
  } catch (e) {
    yield put(errorActions.Saga.setError(e));
  }
}

function* doFetchData(action) {
  yield put(actions.Generator.loading(true));
  try {
    const historyState = HISTORY.location.state;
    const tableState = yield select(selectors.getTableState);
    const results = yield call(OpenAmendmentApi.updateResults, tableState);
    yield put(actions.Generator.tableStateChange({'data': results.data.hits.hits}));
    yield put(actions.Generator.tableStateChange({'pages': Math.ceil(results.data.hits.totalHits / tableState.pageSize)}));
    HISTORY.replace(OPEN_AMENDMENTS_PATH + SearchUrlUtil.buildQueryString(tableState));
    //restore the old scroll position if there is one
    if (historyState) {
      const {scrollTop} = historyState;
      if (scrollTop) {
        window.scroll(0, scrollTop);
      }
    }

  } catch (e) {
    yield put(errorActions.Saga.setError(e));
  }
  yield put(actions.Generator.loading(false));
}

function* openAmendmentsSaga() {
  yield takeLatest(actions.SAGA_TABLE_STATE_CHANGE, updateTable);
  yield takeLatest(actions.SAGA_DO_FETCH_DATA, doFetchData);
  yield takeLatest(actions.SAGA_INIT_OPEN_REQS, initTable);
}


export default function* rootSaga() {
  yield all([
    openAmendmentsSaga(),
    errorSaga()
  ]);
}